/**
 * /platform — redirect to the Professionals console.
 * @file src/web/features/platform/pages/index.tsx
 */
import { Navigate } from 'react-router-dom';
export default function PlatformIndex() {
  return <Navigate to="/platform/professionals" replace />;
}
